( function( $ ) {
	$(document).ready(function() {
		$('[data-toggle="tooltip"]').tooltip({
			template: '<div class="tooltip"><div class="tooltip-arrow listen-arrow primary-border-bottom-color"></div><div class="tooltip-inner primary-border-color"></div></div>'
		});
	});
} )( jQuery );